module.exports = __webpack_public_path__ + "static/HeroVideo-4d696e34266950ac5132d7fd3190b0bf.webm";